import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { TeamIcon } from '../../../../../../common/react/components/TeamIcon';
import { MatchStatus } from '../MatchStatus';
import { MatchStatusTime } from '../MatchStatusTime';
import { MatchStatusCountdown } from '../MatchStatusCountdown';
import { MatchStatusText } from '../MatchStatusText';

export const MatchCardFinal = ( { matchInfo } ) => {

    const [ isCountdown, setIsCountdown ] = useState( false );
    const dispatch = useDispatch();
    const matchStatuses = PULSE.app.common.CONSTANTS.MATCH_STATUS;

    useEffect( () => {
        const matchInfoStatus = PULSE.app.common.match.getMatchStatus( matchInfo.status );

        // to be set up only for live matches, matches starting soon, or past start time but not yet complete
        if ( matchInfoStatus === matchStatuses.LIVE ||
             PULSE.app.common.match.startsWithinAnHour( matchInfoStatus, matchInfo.utcStartTime ) ||
             ( PULSE.app.common.match.isPastStartTime( matchInfo.utcStartTime ) &&
               matchInfoStatus !== matchStatuses.COMPLETED )
        ) {
            dispatch(
                // @ts-expect-error
                window.PULSE.app.redux.actions.match
                    .ADD_MATCH
                    .request( matchInfo.providerId )
            );
        }
    }, [] );

    const liveMatch = useSelector( state => window.PULSE.app.redux.selectors.match.item( state, matchInfo.providerId ) );

    let match = liveMatch || matchInfo;

    if ( !liveMatch ) {
        match.abbr = `${matchInfo.home.team.nickname} v ${matchInfo.away.team.nickname}`;
        match.homeScore = match.home.score?.totalScore;
        match.awayScore = match.away.score?.totalScore;
        match.homeTeamAbbr = match.home.team.abbreviation.toLowerCase();
        match.homeTeamPid = match.home.team.providerId;
        match.awayTeamAbbr = match.away.team.abbreviation.toLowerCase();
        match.awayTeamPid = match.away.team.providerId;
    } else {
        match.homeScore = match.score?.homeTeamScore.matchScore.totalScore;
        match.awayScore = match.score?.awayTeamScore.matchScore.totalScore;
        match.homeTeamAbbr = match.match.homeTeam.abbr.toLowerCase();
        match.homeTeamPid = match.match.homeTeamId;
        match.awayTeamAbbr = match.match.awayTeam.abbr.toLowerCase();
        match.awayTeamPid = match.match.awayTeamId;
        match.utcStartTime = match.match.utcStartTime;
        match.status = match.match.status;
    }

    const genericStatus = PULSE.app.common.match.getMatchStatus( match.status );
    const isFullTime = genericStatus === matchStatuses.COMPLETED;

    // Watch the generic status, when it changes decide to show the countdown or not
    useEffect( () => {
        if ( genericStatus === matchStatuses.UPCOMING && !isCountdown ) {
            setIsCountdown( true );
        } else if ( isCountdown === true ) {
            setIsCountdown( false );
        }
    }, [ genericStatus ] );

    return (
        <a href={PULSE.app.common.url.getMatchURL( matchInfo )} className="fb-match fb-match--final" aria-label={match.abbr}>
            <div className="fb-match__logo fb-match__col">
                <TeamIcon
                    className="fb-match__logo-icon"
                    providerId={ match.homeTeamPid }
                />
            </div>
            <div className='fb-match__col fb-match__info-wrapper'>
                <div className='fb-match__title'>
                    {matchInfo.round.name}
                </div>
                {!isCountdown && (
                    <div className="fb-match__score-container">
                        <div className="fb-match__score-item fb-match__score-item--score">
                            {match.homeScore}
                        </div>
                        <div className={ `fb-match__score-item fb-match__score-item--clock ${ isFullTime ? 'fb-match__score-item--fulltime' : ''}`}>
                            { genericStatus !== matchStatuses.COMPLETED ? (
                                <MatchStatusTime matchInfo={match}></MatchStatusTime>
                            ) : (
                                <MatchStatusText
                                    match={match}
                                    matchStatuses={ matchStatuses }
                                />
                            ) }
                        </div>
                        <div className="fb-match__score-item fb-match__score-item--score">
                            {match.awayScore}
                        </div>
                    </div>
                )}
                {isCountdown && <MatchStatusCountdown match={match}></MatchStatusCountdown>}
                <MatchStatus utcStartTime={ matchInfo.utcStartTime } match={match} isFinals={true} isCountdown={isCountdown}></MatchStatus>
            </div>
            <div className="fb-match__logo fb-match__col">
                <TeamIcon
                    className="fb-match__logo-icon"
                    providerId={ match.awayTeamPid }
                />
            </div>
        </a>
    );
};

MatchCardFinal.propTypes = {
    matchInfo: PropTypes.object.isRequired
};
